import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CookieTkService {
  private apiUrl = "https://" + environment.apiURL+ "/api";

  constructor(private http: HttpClient) { }

  setCookie(token:string, microsoftTk?: string): Observable<any> {
    const objToken =   {
      "fToken": token,
      "provider": microsoftTk ? "microsoft.com" : '',
      "pIdToken": microsoftTk
    }
    return this.http.post(this.apiUrl + '/login', objToken, { withCredentials: true });
  }

  logout(provider: string): Observable<any> {
    const pToken = sessionStorage.getItem('pToken');
    return this.http.post(this.apiUrl + '/logout', { token: pToken, provider }, { withCredentials: true });
  }

  getFbCustomTkByMsalIdTk(token:string): Observable<any> {
    return this.http.post(this.apiUrl + '/login/microsoft', { token }, { withCredentials: true });
  }
}